export const ENVIO_GRATIS = 1
export const RETIRA_COMPRADOR = 2
export const ENVIO_A_CARGO_COMPRADOR = 3
export const CTA_CTE = 6
export const MERCADO_PAGO = 7
